<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-5"></a>
<h2 class="toccwfg">Contents</h2>
<h2 class="toccw"><a href="#/xhtml/06_Chapter_1"><em class="italic">Acknowledgements</em></a></h2>
<h2 class="tocc1"><a href="#/xhtml/07_Chapter_2"><em class="italic">Foreword</em></a></h2>
<h2 class="tocc1"><a href="#/xhtml/08_Chapter_3"><em class="italic">Introduction</em></a></h2>
<h2 class="tocc"><a href="#/xhtml/09_Chapter_4"><span class="tocr bold">Chapter 1</span> A Monastic House</a></h2>
<h2 class="tocc"><span href="#/xhtml/10_Chapter_5" title="Link target outside of Sample"><span class="tocr bold">Chapter 2</span> A Troubled and Rebellious House</span></h2>
<h2 class="tocc"><span href="#/xhtml/11_Chapter_6" title="Link target outside of Sample"><span class="tocr bold">Chapter 3</span> A Scottish House</span></h2>
<h2 class="tocc"><span href="#/xhtml/12_Chapter_7" title="Link target outside of Sample"><span class="tocr bold">Chapter 4</span> A Dynastic House</span></h2>
<h2 class="tocc"><span href="#/xhtml/13_Chapter_8" title="Link target outside of Sample"><span class="tocr bold">Chapter 5</span> A Landscaped House</span></h2>
<h2 class="tocc"><span href="#/xhtml/14_Chapter_9" title="Link target outside of Sample"><span class="tocr bold">Chapter 6</span> A Scandalous House</span></h2>
<h2 class="tocc"><span href="#/xhtml/16_Chapter_11" title="Link target outside of Sample"><span class="tocr bold">Chapter 7</span> A Hidden House</span></h2>
<h2 class="tocc"><span href="#/xhtml/17_Chapter_12" title="Link target outside of Sample"><span class="tocr bold">Chapter 8</span> A Benevolent House</span></h2>
<h2 class="tocc"><span href="#/xhtml/18_Chapter_13" title="Link target outside of Sample"><span class="tocr bold">Chapter 9</span> A Haunted House</span></h2>
<h2 class="tocc"><span href="#/xhtml/19_Chapter_14" title="Link target outside of Sample"><span class="tocr bold">Chapter 10</span> A Caring House</span></h2>
<h2 class="tocc"><span href="#/xhtml/20_Chapter_15" title="Link target outside of Sample"><span class="tocr bold">Chapter 11</span> A People’s House</span></h2>
<h2 class="tocc11"><span href="#/xhtml/21_Chapter_16" title="Link target outside of Sample"><em class="italic">Select Bibliography</em></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?a64a3d8c